<script setup lang="ts">
const { getTranslation } = useLanguage();

const { main: { values } } = getTranslation();

const DELAY_BEFORE_SELECTION = 2000;

const active = ref(0);
onMounted(() => {
  setInterval(() => {
    active.value = (active.value < values.length - 1) ? active.value + 1 : 0;
  }, DELAY_BEFORE_SELECTION);
});
</script>

<template>
  <CommonContainer class="relative cursor-default">
    <CommonSubTitle class="sm:!mb-0 text-white !text-5xl sm:!text-8xl">
      Our Values
    </CommonSubTitle>
    <div class="flex relative justify-center items-center h-[20rem] w-full">
      <div class="z-1 absolute sm:relative top-1/2 -translate-y-1/2 sm:top-auto sm:translate-y-0 h-full w-screen hidden sm:block">
        <CommonLogo
          class="opacity-20"
          as-svg
          color="#2C2164"
        />
      </div>
      <div class="relative sm:absolute top-0 left-0 h-full grid grid-rows-3 grid-cols-2 w-full sm:flex justify-center items-center gap-x-2.5 z-10 flex-col sm:flex-row">
        <div
          v-for="(item, idx) in values"
          :key="item"
          :class="{ '!bg-[#FFB69F] text-white transition-all': idx === active }"
          class="my-4 sm:my-0 relative animate-fade text-[28px] text-center text-accordion-title bg-accordion-body sm:px-12 py-4 font-semibold rounded-layout select-none transition-all duration-1000"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <!--    -->
  </CommonContainer>
</template>
